import CovertLetterContent from './CoverLetterContent';

export default CovertLetterContent;
